"use client";

import { type ReactNode, useEffect, useRef, useState } from "react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@tracify/ui/collapsible";
import { cn } from "@/lib/utils";

const collapsibleContentClassName =
  "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:slide-out-to-top-2 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-top-2";

export function ToolPhaseGroup({
  defaultOpen,
  className,
  children,
  renderTrigger,
}: {
  defaultOpen: boolean;
  className?: string;
  children: ReactNode;
  renderTrigger: (input: { isOpen: boolean }) => ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const hasUserInteractedRef = useRef(false);

  useEffect(() => {
    if (hasUserInteractedRef.current) {
      return;
    }

    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={(open) => {
        hasUserInteractedRef.current = true;
        setIsOpen(open);
      }}
      className={cn("flex flex-col gap-2", className)}
    >
      <CollapsibleTrigger asChild>
        {renderTrigger({ isOpen })}
      </CollapsibleTrigger>

      <CollapsibleContent className={collapsibleContentClassName}>
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
}
